import {match} from 'path-to-regexp'
import {BASE_APP_PATH} from 'routes'

export const getSectorFromURL = () => {
  const baseAppPath = `${BASE_APP_PATH}/(.*)`
  const pathMatcher = match(baseAppPath, {decode: decodeURIComponent})
  const matchedPath = pathMatcher(window.location.pathname)
  return matchedPath && matchedPath.params && matchedPath.params.sectorId
}
